<template>
	<el-descriptions style="margin-top: 20px;margin-bottom: 20px;" size="mini" class="margin-top" title="申请信息" border>
		<el-descriptions-item v-if="biao.hosp">
			<template slot="label">
				<i class="el-icon-office-building"></i>
				申请机构
			</template>
			{{biao.hosp}}
		</el-descriptions-item>
		<el-descriptions-item v-if="biao.type">
			<template slot="label">
				<i class="el-icon-paperclip"></i>
				申请类型
			</template>
			{{biao.type}}
		</el-descriptions-item>
		<el-descriptions-item v-if="cjtypes">
			<template slot="label">
				评残类型
			</template>
			<span style="margin-left: 5px;margin-right: 5px;" v-for="(p,i) in cjtypes" :key="i">{{p}}</span>
		</el-descriptions-item>
		<el-descriptions-item >
			<template slot="label">
				上门评残
			</template>
			<el-tag size="mini" :type="biao.is_shangmen==1?'danger':'info'">
				{{biao.is_shangmen==0?'不需要':'需要'}}
			</el-tag>
		</el-descriptions-item>
		<el-descriptions-item v-if="biao.marry">
			<template slot="label">
				婚姻情况
			</template>
			{{biao.marry}}
		</el-descriptions-item>
		<el-descriptions-item v-if="biao.edu">
			<template slot="label">
				教育状况
			</template>
			{{biao.edu}}
		</el-descriptions-item>
		<el-descriptions-item v-if="biao.guanxi">
			<template slot="label">
				监护人与本人关系
			</template>
			{{biao.guanxi}}
		</el-descriptions-item>
		<el-descriptions-item v-if="biao.guanxi">
			<template slot="label">
				监护人与本人关系
			</template>
			{{biao.guanxi}}
		</el-descriptions-item>
	</el-descriptions>
</template>

<script>
	export default{
		data(){
			return{
				
			}
		},
		computed:{
			cjtypes(){
				
				return this.biao.cjtypes;
			}
			
		},
		watch:{
			biao(){
			  	
			}
		},
		props:["biao"],
		created() {
			
		}
	}
</script>

<style>
</style>
